import { render, staticRenderFns } from "./CarAdmission.vue?vue&type=template&id=2f5b106e&scoped=true&"
import script from "./CarAdmission.vue?vue&type=script&lang=js&"
export * from "./CarAdmission.vue?vue&type=script&lang=js&"
import style0 from "./CarAdmission.vue?vue&type=style&index=0&id=2f5b106e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b106e",
  null
  
)

export default component.exports